import { MacrotemaFaq } from '@hm_app/@core/models/info';
import { Struttura } from '@hm_app/@core/models/struttura';
import { Injectable, Type } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';

@Injectable()
export class FaqMacrotemiService {

    // Observable sources
    private macrotema = new BehaviorSubject<MacrotemaFaq>(null);

    // Observable streams
    macrotemaObservable = this.macrotema.asObservable();

    // Service message commands
    passMacrotema(macrotema: MacrotemaFaq) {
        this.macrotema.next(macrotema);
    }
}
